export default __webpack_public_path__ + "static/media/SEA_7361.68f96236.jpg";